<template>
  <div>

    <h1>Summary API Log</h1>

    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-12 col-md-4">
            <label>Date Range</label>
            <flat-pickr v-model="selected.date" :config="rangeConfig" placeholder="Select To Date" />
          </div>
          <div class="col-md-4 row" style="display: flex; flex-direction: column; justify-content: flex-end;">
            <button class="btn btn-primary w-100" type="button" @click="fetchData"
              style="height: 43px; margin-top:7px">
              <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
            </button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <summary-api-bar-chart
      v-if="dataReady"
      :data="summaryChartData"
    ></summary-api-bar-chart>

    <div class="row mt-5">
      <div class="col-12 col-md-6" style="display: flex; flex-direction: column; justify-content: flex-end;">
        <h3 class="pl-3">Detail Summary Per Day</h3>
      </div>
      <div class="col-12 col-md-6">
        <label>Select Activity</label>
        <Multiselect 
          v-if="activityList"
          :options="activityList"
          :multiple="true"
          :allow-empty="false"
          v-model="localFilter.activity"
        />
      </div>
      <div class="col-md-8"></div>
      <div class="col-12 col-md-4 text-right">
        <button class="btn btn-sm btn-outline-danger mr-5" style="width: 85px;" @click="clearActivity">Clear</button>
        <button class="btn btn-sm btn-outline-primary" style="width: 85px;" @click="selectAllActivity">Select All</button>
      </div>
    </div>

    <!-- Table Content Start -->
    <div style="max-height:700px; width: 100%; overflow: auto;" v-if="dataReady">
      <table class="table">
        <thead>
          <tr>
            <th rowspan="2">Date</th>
            <th
              v-for="activity in activityList"
              v-if="localFilter.activity.indexOf(activity) !== -1"
              colspan="2"
            >{{ activity }}</td>
          </th>
          <tr>
            <template v-for="activity in localFilter.activity">
              <th style="color: rgb(145, 201, 145);">Success</th>
              <th style="color: rgb(212, 188, 188);">Failure</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in summaryApiLogData">
            <td class="dateSection">{{ data.date }}</td>
            <template
              v-for="(activity, activityName) in data.activity"
              v-if="localFilter.activity.indexOf(activityName) !== -1"
            >
              <td>{{activity.success}}</td>
              <td @click="downloadErrorLog(data.date, activityName)">{{activity.error}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Table Content End -->

  </div>
</template>

<script>
  import qs from 'qs';
  const XLSX = require('xlsx');
  import moment from 'moment';
  import Multiselect from 'vue-multiselect';
  import flatPickr from 'vue-flatpickr-component';

  import summaryApiBarChart from './children/summaryApiBarChart';

  export default {
    data() {
      let date = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().endOf('month').format('Y-MM-DD')}`
      return {
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL()
        },

        selected: {
          date: date,
        },
        filter: {
          start: date.split(' to ')[0],
          end: date.split(' to ')[1],
        },
        localFilter: {
          activity : [],
        },

        summaryChartData : null,
        summaryApiLogData : null,
        activityList : null,

        dataReady : false,
      }
    },
    components: {
      Multiselect,
      flatPickr,

      summaryApiBarChart,
    },
    mounted() {
      this.fetchData();
    },
    watch: {
      filterOptChosen: {
        handler() {
          this.keyword = '';
          for (var i in this.filterOpt) delete this.filter[this.filterOpt[i].value];
        },
        deep: true,
      },
      keyword: {
        handler() {
          this.filter[this.filterOptChosen.value] = this.keyword
        }
      },
      'selected.date'() {
        let splitDateRange = this.selected.date.split(' to ');
        this.filter.start = splitDateRange[0]
        this.filter.end = splitDateRange[1]
      },
    },
    methods: {
      fetchData () {
		    var user = this.$store.state.userData.userData;
        let token = "Bearer " + user.token;

        this.$http.get(`/api/reports/log-api${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}` , {headers : {Authorization : token}})
        .then(async (resp)=>{
          this.summaryChartData = await this.convertSummaryChartData(resp.data.meta);
          this.summaryApiLogData = await this.convertSummaryApiLogData(resp.data.data);

          this.activityList = resp.data.data[0].activity.map(x=>x.name);
          this.activityList.push("Total");
          this.localFilter.activity = this.activityList.slice(0, this.activityList.length>3 ? 3 : this.activityList.length);
        })
        .then(()=>{
          this.dataReady = true;
        })
        .catch((err)=>{console.log(err)})
      },
      convertSummaryChartData (oldData) {
        let data = JSON.parse(JSON.stringify(oldData.summary));
        let result = [];
        
        for (var i in data) {
          result.push({
            code : i.split("_")[1],
            count : data[i]
          })
        }

        return result;
      },
      convertSummaryApiLogData (oldData) {
        let data = JSON.parse(JSON.stringify(oldData));

        for (var i in data) {//Each Date
          let newActivity = {};

          let totalSuccess = 0;
          let totalError = 0;

          for (var j in data[i].activity) {//Each Activity
            totalSuccess += data[i].activity[j].success;
            totalError += data[i].activity[j].error;

            newActivity[data[i].activity[j].name] = {
              success: data[i].activity[j].success,
              error: data[i].activity[j].error
            }
          }
          newActivity['Total'] = {success:totalSuccess, error:totalError};
          data[i].activity = newActivity;
        }

        return data
      },
      clearActivity () {
        this.localFilter.activity.splice(1);
      },
      selectAllActivity () {
        this.localFilter.activity.splice(0);
        for (var i in this.activityList) this.localFilter.activity.splice(this.localFilter.activity.length, 0, this.activityList[i])
      },

      downloadErrorLog (date, activity) {
        let token = "Bearer " + this.$store.state.userData.userData.token;
        this.$http.get(`/api/reports/log-api/download-detail?date=${date}&activity=${activity}` , {headers : {Authorization : token}})
        .then((resp)=>{
            let wb = XLSX.utils.book_new()
            var ws = XLSX.utils.json_to_sheet(resp.data.data, {raw:true});
            XLSX.utils.book_append_sheet(wb, ws, 'Data')
            XLSX.writeFile(wb, `Summary ${activity} API ${date}.xlsx`)
        })
        .catch((err)=>{console.log(err)})
      },
    }
  }
</script>

<style scoped>
  table {
    border: 2px solid rgb(110, 110, 110);
  }

  table thead tr th {
    text-align: center;
    vertical-align: middle;
    background-color: grey;
    color: white;
  }

  table tbody tr td {
    text-align: center;
    vertical-align: middle;
  }

  /* Remove if complaint start */
  table tbody {
    display: block;
    height: 600px;
    overflow: auto;
  }

  thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  thead {
    width: calc(100% - 1em);
  }
  table {
    width: 100%;
  }
  /* Remove if complaint end */

  .dateSection {
    font-weight: bold;
  }
</style>